module.exports = __webpack_public_path__ + "static/media/GroupCallIIcon.94ae860e.svg";